import React, { Component } from 'react';
import './App.css';
class Tabs extends Component {

 
  render() {
    if(this.props.recentSearches.length > 0){
      const res = this.props.recentSearches.map((content, i) =>
        (
          <li key={i}>
            <a onClick={this.props.changeTab.bind(this, content)}>{content}</a>
          </li>
        ));
      return(
        <div className="searchArea__previous">
            <p>Previous searches</p>
            <ul>
                {res}
            </ul>
        </div>
      );
    }
    else {
      return(
        <div className="searchArea__previous">
            <p>Previous searches</p>
        </div>
      );
    }
  }
}

export default Tabs;

 


// WEBPACK FOOTER //
// ./client/src/Buttons.js